import * as React from 'react';
import { Component } from 'react';
import { Field, Form, getFormValues, reduxForm } from 'redux-form';
import Textarea from '../../components/Textarea';
import autobind from 'autobind-decorator';
import {
  __,
  mapStateToProps,
  redirect,
  setFormValue,
  dateFrom,
  getLocalized,
} from '../../core/utils';
import { enableAutosave } from '../../redux/actions/general/autosave';
import { listPlanningLibraryItems } from '../../redux/actions/table/planning_library';
import styles from '../../styles/forms/tasks/EditTaskForm.scss';
import Input from '../../components/Input';
import TaskRfiIcon from '../../assets/images/task-rfi-15x15.svg';
import classNames from 'classnames';
import TaskFyiIcon from '../../assets/images/task-fyi-15x15.svg';
import TaskDecisionIcon from '../../assets/images/task-decision-15x15.svg';
import TaskTodoIcon from '../../assets/images/task-todo-15x15.svg';
import TaskMilestoneIcon from '../../assets/images/task-milestone-15x15.svg';
import TaskIssueIcon from '../../assets/images/task-issue-15x15.svg';
import TaskGroupIcon from '../../assets/images/task-group-icon.svg';
import LogoIcon from '../../assets/images/logo-50x50.svg';
import Select from '../../components/Select';
import PeopleChooser from '../../components/PeopleChooser';
import Tags from '../../components/Tags';
import {
  listPossibleTaskAssignee,
  listPossibleTaskFollowers,
  updateTaskSpaceAllocation,
  listAllTasks,
  updateTaskType,
} from '../../redux/actions/table/all_tasks';
import { withRouter } from 'react-router';
import * as _ from 'lodash';
import MultiSelect from '../../components/MultiSelect';
import ArrowDownMiddleIcon from '../../assets/images/arrow-down-middle-15x15.svg';
import ArrowDownSmallIcon from '../../assets/images/arrow-down-small-15x15.svg';
import { listPossibleStageDisciplines } from '../../redux/actions/table/teams';
import { subscribe } from 'react-contextual/dist/react-contextual.es';
import Localization from '../../helpers/Localization';
import TargetIcon from '../../assets/images/target-15x15.svg';
import Tooltip from '../../components/Tooltip';
import Dropdown from '../../components/Dropdown';
import { listPossibleTags } from '../../redux/actions/general';
import RoomChooser from '../../components/RoomChooser';
import { hideDropdown } from '../../redux/actions/general/dropdown';
import { setNotification } from '../../redux/actions/general/notification';
import {
  hideAlertbox,
  showAlertbox,
} from '../../redux/actions/general/alertbox';
import RangeSlider from '../../components/Slider';
import DateTimePicker from '../../components/DateTimePicker';
import Checkbox from '../../components/Checkbox';
import moment from 'moment';
import {
  filterTaskPeopleOptionsByCompany,
  filterTaskPeopleValueByCompany,
  TASK_VISIBILITY_COMPANY,
} from '../../helpers/taskPeopleVisibility';

@reduxForm({
  form: 'tasks.edit_task',
  enableReinitialize: true,
})
@withRouter
@subscribe(Localization, 'localization')
@mapStateToProps((state) => ({
  values: getFormValues('tasks.edit_task')(state),
  auth: state.auth,
}))
class EditTaskForm extends Component {
  constructor(props) {
    super(props);

    this.state = {
      possible_task_assignee: [],
      possible_task_followers: [],
      stage_tags: [],
      possible_stage_disciplines: [],
      task_type_active: false,
      planningLibraryItems: [],
    };
  }

  componentDidMount() {
    const {
      data,
      localization: { disciplines },
    } = this.props;
    const stage_id = data.stage.id;
    const project_id = data.project.id;

    listPlanningLibraryItems('group', false, true).then(({ response }) => {
      this.setState({
        planningLibraryItems: _.map(
          response.data,
          (item) => ({
            value: item.id,
            label: [
              getLocalized(item.name, this.props.auth.language_id),
              item.code,
            ].filter(Boolean).join(' - '),
            icon: (
              <Tooltip
                text={item.is_system
                  ? __('planning-templates.source.system')
                  : __('planning-templates.source.my-company')}
              >
                <span
                  className={classNames(
                    styles.planningTemplateSource,
                    item.is_system ? styles.systemSource : styles.companySource,
                  )}
                >
                  {item.is_system ? <LogoIcon /> : 'MY'}
                </span>
              </Tooltip>
            ),
          }),
        ),
      });
    });

    listPossibleTaskAssignee(stage_id).then(({ response }) => {
      this.setState({
        possible_task_assignee: _.map(response.data, (data) => {
          return data.type === 'discipline'
            ? {
                ...data,
                name: `${[
                  data.company_name,
                  [
                    data.stage_discipline.code,
                    data.stage_discipline.discipline_id == null
                      ? data.stage_discipline.description + '*'
                      : _.get(disciplines, [
                          data.stage_discipline.discipline_id,
                          'name',
                        ]),
                  ].join(': '),
                ].join(' | ')}`,
              }
            : data;
        }),
      });
    });

    listPossibleTaskFollowers(stage_id).then(({ response }) => {
      this.setState({
        possible_task_followers: _.map(response.data, (data) => {
          return data.type === 'discipline'
            ? {
                ...data,
                name: `${[
                  data.company_name,
                  [
                    data.stage_discipline.code,
                    data.stage_discipline.discipline_id == null
                      ? data.stage_discipline.description + '*'
                      : _.get(disciplines, [
                          data.stage_discipline.discipline_id,
                          'name',
                        ]),
                  ].join(': '),
                ].join(' | ')}`,
              }
            : data;
        }),
      });
    });

    listPossibleTags('project', project_id).then(({ response }) => {
      this.setState({ stage_tags: response.data });
    });

    listPossibleStageDisciplines(stage_id).then(({ response }) => {
      this.setState({ possible_stage_disciplines: response.data });
    });

    this._removeUnavailableCompanyPeople();
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.data.visibility !== this.props.data.visibility ||
      !_.isEqual(prevProps.values?.assignee, this.props.values?.assignee) ||
      !_.isEqual(prevProps.values?.followers, this.props.values?.followers)
    ) {
      this._removeUnavailableCompanyPeople();
    }
  }

  _visibility() {
    return _.toString(_.get(this.props.data, 'visibility', '1'));
  }

  _companyId() {
    return _.get(
      this.props.data,
      'creator.company_id',
      _.get(
        this.props.auth,
        'company.id',
        _.get(this.props.auth, 'company_id'),
      ),
    );
  }

  _removeUnavailableCompanyPeople() {
    const visibility = this._visibility();
    const companyId = this._companyId();

    if (visibility !== TASK_VISIBILITY_COMPANY) {
      return;
    }

    _.each(['assignee', 'followers'], (field) => {
      const value = _.get(this.props.values, field, []);
      const filtered = filterTaskPeopleValueByCompany(
        value,
        companyId,
        visibility,
      );

      if (!_.isEqual(value, filtered)) {
        this.props.change(field, filtered);
      }
    });
  }

  UNSAFE_componentWillReceiveProps() {
    enableAutosave(this.props.form);
  }

  @autobind
  _handleSpaceAllocation(values) {
    const { id } = this.props.data;

    this.props.change('space_allocation', values);

    updateTaskSpaceAllocation(id, {
      space_allocation: _.reduce(
        _.keys(values),
        (space_allocation, value) => {
          const [space_allocation_type, space_allocation_id] = _.split(
            value,
            ':',
          );

          if (!_.isArray(space_allocation[space_allocation_type])) {
            space_allocation[space_allocation_type] = [];
          }

          space_allocation[space_allocation_type].push(space_allocation_id);

          return space_allocation;
        },
        {},
      ),
    })
      .then(() => {
        this.props.match.params.stage &&
          listAllTasks(this.props.match.params.stage);
      })
      .then(() => {
        setNotification(__('tasks.properties.saved'));
      });

    hideDropdown();
  }

  _dependencyCount() {
    const dependencies = _.get(this.props.data, 'dependencies', {});

    return (
      _.size(_.get(dependencies, 'predecessors', [])) +
      _.size(_.get(dependencies, 'successors', []))
    );
  }

  _applyTaskType(type) {
    const { data, match, readAction } = this.props;

    return updateTaskType(data.id, type)
      .then(() => {
        this.props.change('type', type);

        return match.params.stage && listAllTasks(match.params.stage);
      })
      .then(() => readAction && readAction(data.id))
      .then(() => {
        hideAlertbox();
        setNotification(__('tasks.properties.saved'));
      });
  }

  @autobind
  _handleTaskTypeChange(type) {
    if (this.props.lockTaskType) return;
    const { data } = this.props;

    if (type === data.type) {
      return;
    }

    const dependencies = _.get(this.props.data, 'dependencies', {});

    const dependencyCount =
      _.size(_.get(dependencies, 'predecessors', [])) +
      _.size(_.get(dependencies, 'successors', []));

    if (data.type === 'group' && type !== 'group' && dependencyCount > 0) {
      showAlertbox({
        color: 'red',
        title: __('general.alert.are-you-sure'),
        description: __('tasks.type.confirm-change-from-group-description'),
        buttons: [
          {
            color: 'lightGray',
            text: __('general.alert.no-close'),
            onClick: () => hideAlertbox(),
          },
          {
            color: 'gray',
            text: __('general.alert.yes-delete'),
            onClick: () => {
              hideAlertbox();
              this._applyTaskType(type);
            },
          },
        ],
      });

      return;
    }

    this._applyTaskType(type);
  }

  render() {
    const { data, handleSubmit, possibleSpaceAllocation } = this.props;
    const { creator, is_editor, status } = data;
    const project_languages = data.project.languages;
    const {
      possible_stage_disciplines,
      stage_tags,
      possible_task_assignee,
      possible_task_followers,
    } = this.state;
    const { disciplines } = this.props.localization;
    const disabled = !is_editor || _.includes(['closed', 'canceled'], status);
    const isDeadline = _.get(this.props.values, 'date.deadline') === 1;
    const hasDates =
      !!_.get(this.props.values, 'date.start') &&
      !!_.get(this.props.values, 'date.end');
    const hasBudgetAccess = _.includes(
      _.get(data, 'budget_access.permissions', []),
      'view.budget',
    );
    const visibility = this._visibility();
    const companyId = this._companyId();
    const visibleTaskAssignee = filterTaskPeopleOptionsByCompany(
      possible_task_assignee,
      companyId,
      visibility,
    );
    const visibleTaskFollowers = filterTaskPeopleOptionsByCompany(
      possible_task_followers,
      companyId,
      visibility,
    );

    const types = [
      {
        value: 'rfi',
        label: __('tasks.type.rfi'),
        icon: (hover, active, selected) => (
          <TaskRfiIcon
            className={classNames(
              styles.rfiIcon,
              active && styles.active,
              selected && styles.selected,
            )}
          />
        ),
      },
      {
        value: 'fyi',
        label: __('tasks.type.fyi'),
        icon: (hover, active, selected) => (
          <TaskFyiIcon
            className={classNames(
              styles.fyiIcon,
              active && styles.active,
              selected && styles.selected,
            )}
          />
        ),
      },
      {
        value: 'decision',
        label: __('tasks.type.decision'),
        icon: (hover, active, selected) => (
          <TaskDecisionIcon
            className={classNames(
              styles.decisionIcon,
              active && styles.active,
              selected && styles.selected,
            )}
          />
        ),
      },
      {
        value: 'todo',
        label: __('tasks.type.todo'),
        icon: (hover, active, selected) => (
          <TaskTodoIcon
            className={classNames(
              styles.todoIcon,
              active && styles.active,
              selected && styles.selected,
            )}
          />
        ),
      },
      {
        value: 'milestone',
        label: __('tasks.type.milestone'),
        icon: (hover, active, selected) => (
          <TaskMilestoneIcon
            className={classNames(
              styles.milestoneIcon,
              active && styles.active,
              selected && styles.selected,
            )}
          />
        ),
      },
      {
        value: 'issue',
        label: __('tasks.type.issue'),
        icon: (hover, active, selected) => (
          <TaskIssueIcon
            className={classNames(
              styles.issueIcon,
              active && styles.active,
              selected && styles.selected,
            )}
          />
        ),
      },
      {
        value: 'group',
        label: __('tasks.type.group'),
        icon: (hover, active, selected) => (
          <TaskGroupIcon
            className={classNames(
              styles.groupIcon,
              active && styles.active,
              selected && styles.selected,
            )}
          />
        ),
      },
    ];

    const initialSpaceAllocation = _.get(
      this.props.values,
      'space_allocation',
      [],
    );
    const taskType = _.get(this.props.values, 'type', data.type);

    const formatDate = (date, allDay) =>
      moment
        .utc(date)
        .local()
        .format(allDay === 1 ? 'DD.MM.YYYY' : 'DD.MM.YY HH:mm');

    return (
      <Form onSubmit={handleSubmit}>
        <div className={styles.section}>
          <div className={styles.flex}>
            <div className={styles.f3}>
              <Select
                disabled={disabled || this.props.lockTaskType}
                input={{
                  name: 'type',
                  value: taskType,
                  onChange: this._handleTaskTypeChange,
                  onBlur: () => this.setState({ task_type_active: false }),
                  onFocus: () => this.setState({ task_type_active: true }),
                }}
                meta={{
                  active: this.state.task_type_active,
                  form: this.props.form,
                }}
                noSort
                label={__('tasks.flyout.type')}
                options={types}
              />
            </div>
            <div className={styles.f7}>
              <Field
                disabled={disabled}
                name='title'
                component={Input}
                label={__('tasks.flyout.title')}
                maxLength={60}
              />
            </div>
          </div>
          {taskType === 'group' && (
            <div className={styles.flex}>
              <div className={styles.f3} />
              <div className={styles.f7}>
                <Field
                  disabled={disabled}
                  name='group_template_id'
                  component={Select}
                  label={__('tasks.flyout.group-templates')}
                  options={this.state.planningLibraryItems}
                  searchable
                  noSort
                />
              </div>
            </div>
          )}
          <Field
            disabled={disabled}
            name='description'
            localized={project_languages}
            component={Textarea}
            label={__('tasks.flyout.description')}
            maxLength={2000}
            rows={1}
            maxRows={10}
            placeholder={__('tasks.flyout.add-description')}
          />
          <div className={styles.flex}>
            <div className={styles.f2}>
              <Field
                name='date'
                component={DateTimePicker}
                label={__('tasks.flyout.date')}
                footer
                clearDate
                dropdown
                range
                time
                lockEndDate={isDeadline}
                disabled={disabled}
                // top={32}
                presets
                wrapper={(handleOpen, value) => (
                  <Tooltip text={__('tasks.tooltips.datetime.change-date')}>
                    <div
                      className={classNames(
                        styles.date,
                        !(value.start && value.end) && styles.dateEmpty,
                        disabled && styles.disabled,
                      )}
                      onClick={handleOpen}
                    >
                      {/* {value.start && value.end
                        ? moment
                            .utc(value.start)
                            .local()
                            .startOf('day')
                            .format('X') ==
                          moment
                            .utc(value.end)
                            .local()
                            .startOf('day')
                            .format('X')
                          ? dateFrom(value.start)
                          : dateFrom(value.start) + ' - ' + dateFrom(value.end)
                        : __('tasks.flyout.select-date')} */}

                      {/* {value.start && value.end
                        ? moment
                            .utc(value.start)
                            .local()
                            .isSame(moment.utc(value.end).local(), 'day')
                          ? moment
                              .utc(value.start)
                              .local()
                              .format('DD.MM.YY HH:mm')
                          : `${moment
                              .utc(value.start)
                              .local()
                              .format('DD.MM.YY HH:mm')} - ${moment
                              .utc(value.end)
                              .local()
                              .format('DD.MM.YY HH:mm')}`
                        : __('tasks.flyout.select-date')} */}

                      {value.start && value.end
                        ? moment
                            .utc(value.start)
                            .local()
                            .isSame(moment.utc(value.end).local(), 'day')
                          ? formatDate(value.start, value.allDay)
                          : `${formatDate(
                              value.start,
                              value.allDay,
                            )} - ${formatDate(value.end, value.allDay)}`
                        : __('tasks.flyout.select-date')}
                      <ArrowDownSmallIcon />
                    </div>
                  </Tooltip>
                )}
              />
            </div>
            {/* <div className={styles.f1}>
              <Field
                name='date.end'
                component={DateTimePicker}
                label={__('tasks.flyout.end-date')}
                footer
                // dropdown
                // range
                time
                // top={32}
                // clearDate
              />
            </div> */}
            <div className={classNames(styles.f1, styles.duration)}>
              <Field
                name='date.duration'
                component={Input}
                label={__('tasks.flyout.duration')}
                placeholder={__('tasks.flyout.enter-duration')}
                disabled={isDeadline || disabled || !hasDates}
              />
            </div>
            <div className={classNames(styles.f1, styles.deadline)}>
              <div className={styles.deadlineLabel}>
                {__('tasks.flyout.deadline')}
              </div>
              <Field
                name='date.deadline'
                component={Checkbox}
                // label={__('deadline')}
                className={styles.checkbox}
                onChange={(event) => {}}
                disabled={disabled}
              />{' '}
            </div>

            {hasBudgetAccess ? (
              <div className={classNames(styles.f1, styles.estimate)}>
                <Field
                  name='time_log.planned_time'
                  component={Input}
                  label={__('tasks.flyout.planned-time')}
                  placeholder={__('tasks.flyout.enter-planned-time')}
                  disabled={disabled}
                />
              </div>
            ) : (
              <div
                className={classNames(
                  styles.f1,
                  styles.estimate,
                  styles.estimatePlaceholder,
                )}
              />
            )}
          </div>
        </div>
        <div className={styles.section}>
          <div className={styles.flex}>
            <div className={styles.f1}>
              <div className={styles.flex}>
                <div className={styles.f1}>
                  <Field
                    disabled={true}
                    name='creator'
                    component={PeopleChooser}
                    label={__('tasks.flyout.owner')}
                    options={[creator]}
                  />
                </div>
                <div className={styles.f4}>
                  <Field
                    disabled={disabled}
                    limit={7}
                    name='assignee'
                    component={PeopleChooser}
                    label={__('tasks.flyout.assignee')}
                    searchable
                    options={visibleTaskAssignee}
                    placeholder={__('tasks.flyout.select-assignee')}
                  />
                </div>
              </div>
            </div>
            <div className={styles.f1}>
              <Field
                disabled={disabled}
                limit={10}
                name='followers'
                component={PeopleChooser}
                label={__('tasks.flyout.followers')}
                searchable
                options={visibleTaskFollowers}
                placeholder={__('tasks.flyout.select-followers')}
              />
            </div>
          </div>
        </div>
        <div className={styles.section}>
          <div className={styles.flex}>
            <div className={styles.f1}>
              <Field
                disabled={disabled}
                name='stage_disciplines'
                searchable={true}
                component={MultiSelect}
                label={__('tasks.flyout.disciplines')}
                options={_.map(
                  possible_stage_disciplines,
                  (stage_discipline) => ({
                    value: stage_discipline.id,
                    label: [
                      stage_discipline.code,
                      stage_discipline.discipline_id == null
                        ? stage_discipline.description + '*'
                        : _.get(disciplines, [
                            stage_discipline.discipline_id,
                            'name',
                          ]),
                    ].join(': '),
                  }),
                )}
                placeholder={__('tasks.flyout.select-stage_disciplines')}
              />
            </div>
            <div className={styles.f1}>
              <Field
                disabled={disabled}
                name='tags'
                component={Tags}
                label={__('tasks.flyout.tags')}
                options={stage_tags}
                placeholder={__('tasks.flyout.select-tags')}
              />
            </div>
          </div>
          {(!_.isEmpty(data.plan_versions) ||
            !_.isEmpty(data.plan_revisions)) && (
            <div className={styles.goto}>
              <Dropdown
                leftStyled
                top={30}
                left={0}
                name={'tasks_flyout.' + data.id}
                header={
                  <div className={styles.targetDropdownHeader}>
                    {__('table.columns.goto')}
                    <TargetIcon />
                  </div>
                }
                content={
                  <div className={styles.targetDropdownContent}>
                    {_.map(data.plan_versions, (version, i) => (
                      <div
                        className={styles.item}
                        key={i}
                        onClick={(e) => {
                          e.preventDefault();
                          redirect(
                            '/plans/versions/' +
                              version.id +
                              '?task_id=' +
                              data.id,
                          );
                        }}
                      >
                        <Tooltip
                          text={version.name + (' (V' + version.number + ')')}
                        >
                          <span>
                            {version.name + (' (V' + version.number + ')')}
                          </span>
                        </Tooltip>
                        <div className={styles.dot} />
                      </div>
                    ))}
                    {_.map(data.plan_revisions, (revision, i) => (
                      <div
                        className={styles.item}
                        key={i}
                        onClick={(e) => {
                          e.preventDefault();
                          redirect(
                            '/plans/revisions/' +
                              revision.id +
                              '?task_id=' +
                              data.id,
                          );
                        }}
                      >
                        <Tooltip
                          text={revision.name + (' (V' + revision.number + ')')}
                        >
                          <span>
                            {revision.name + (' (V' + revision.number + ')')}
                          </span>
                        </Tooltip>
                        <div className={styles.dot} />
                      </div>
                    ))}
                  </div>
                }
              >
                <button type='button'>
                  <TargetIcon /> {__('table.columns.goto')}{' '}
                  <ArrowDownMiddleIcon />
                </button>
              </Dropdown>
            </div>
          )}
          <Dropdown
            top={25}
            right={-20}
            wrapperClassName={styles.dropdownWrapper}
            name={'tasks_flyout_area.' + data.id}
            header={
              <div className={styles.dropdownHeader}>
                {__('table.area-tab.area')}
              </div>
            }
            content={
              <div className={classNames(styles.dropdownContent, styles.space)}>
                <RoomChooser
                  multiselect={true}
                  onCancel={hideDropdown}
                  options={possibleSpaceAllocation}
                  onDone={this._handleSpaceAllocation}
                  initialValues={initialSpaceAllocation}
                />
              </div>
            }
          >
            <label className={styles.spaceAllocationLabel}>
              {__('general.label.space-allocation')}
            </label>
            <div className={styles.tagsGroup} onClick={this._handleOpen}>
              {_.size(initialSpaceAllocation) == 0 ? (
                <span className={styles.placeholder}>
                  {__('tasks.flyout.select-area')}
                </span>
              ) : (
                <div className={styles.tags}>
                  {_.map(_.sortBy(initialSpaceAllocation), (tag, i) => (
                    <span key={i}>{tag.display_name}</span>
                  ))}
                </div>
              )}
              {!this.props.center && !this.props.disabled && (
                <ArrowDownMiddleIcon />
              )}
            </div>
          </Dropdown>
        </div>
      </Form>
    );
  }
}

export default EditTaskForm;
